import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import CategoryFacetItem from '~/components/molecules/Category/CategoryFacetItem.vue';
export default {
  name: 'CategoryCheckboxFilter',
  components: {
    CategoryFacetItem
  },
  props: {
    selected: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      active: false,
      showAll: false,
      maxItems: 6,
      checkedFacets: []
    };
  },

  computed: {
    facets() {
      const facets = this.filter.facets.filter(e => e.label);
      return this.showAll || this.isColor ? facets : facets.slice(0, 16);
    },

    isColor() {
      return ['color', 'segmentations.colors.label'].includes(this.filter.name);
    },

    checkboxClasses() {
      return {
        'justify-content-lg-center': !this.isColor && this.facets.length <= 4 && !this.desktopLayer,
        'justify-content-lg-start m-auto': this.isColor || this.facets.length > 4 || this.desktopLayer,
        'flex-md-row': !this.desktopLayer
      };
    }

  },
  watch: {
    filter() {
      this.showAll = false;
      this.checkedFacets = this.facets ? this.facets.filter(f => f.selected).map(f => f.key) : [];
    }

  },

  mounted() {
    this.checkedFacets = this.facets ? this.facets.filter(f => f.selected).map(f => f.key) : [];
  },

  methods: _objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY'
  }), {
    selectedFacet(facet) {
      return this.selected.map(e => e.facet).includes(facet);
    },

    tracking(facet) {
      const filter = "".concat(this.filter.label.charAt(0).toUpperCase()).concat(this.filter.label.slice(1));
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: "Filtre_".concat(filter, "_").concat(facet.label),
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },

    applyCheckboxChanges(facet, evt) {
      this.filterBy({
        filter: this.filter.name,
        facet: facet.key
      });
      this.$root.$emit('generic-tracking', evt, this.tracking(facet));
      if (!this.checkedFacets.includes(facet.key)) this.checkedFacets.push(facet.key);else this.checkedFacets = this.checkedFacets.filter(e => e !== facet.key);
    },

    seeMore() {
      this.showAll = true;
    }

  })
};